import { NO_VALUE_SET, type UOutcomes } from '../../coupon/entry.js';
import { OUTCOME_MAP_1X2 } from './utils.js';

/**
 * Parses a U row 1x2 board.
 *
 * @param boardData The board data to parse.
 * @returns The parsed board data.
 */
export function parseURow1x2(boardData: string[]): UOutcomes {
  return boardData.map((outcome) => OUTCOME_MAP_1X2.get(outcome) ?? NO_VALUE_SET);
}
